<filter-editor
    [fields]="(fields$ | async) ?? []"
    [isFieldGroupingApplied]="true"
    [filter]="adapterFilter"
    [fieldPickerLabel]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE_FILTER.FILTER_LABEL' | translate"
    (filterChanged)="onFilterChanged($event)"
/>
